var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 20.1668C5.93706 20.1668 1.83301 16.0628 1.83301 11.0002C1.83301 5.93755 5.93706 1.8335 10.9997 1.8335C16.0623 1.8335 20.1663 5.93755 20.1663 11.0002C20.1608 16.0605 16.06 20.1613 10.9997 20.1668ZM10.083 3.72366C7.08188 4.10319 4.62176 6.28656 3.88846 9.22136C3.15515 12.1562 4.29917 15.2401 6.76907 16.9866C9.23896 18.7332 12.5278 18.7839 15.0504 17.1143L14.9588 17.1794L15.0449 17.1198L15.099 17.0822L15.1577 17.041L15.1723 17.0309L15.1806 17.0245L10.4799 12.322C10.2245 12.0621 10.0819 11.712 10.083 11.3476V3.72366ZM12.6763 11.9168L16.551 15.7916L16.5574 15.7842L16.562 15.7787L16.5528 15.7888C17.4985 14.6976 18.0983 13.3498 18.2762 11.9168H12.6763ZM11.9163 3.72366V10.0835H18.2762C17.8577 6.75976 15.2401 4.14213 11.9163 3.72366Z",
    fill: "#6C6A81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.78737aed467e016ecf81476ec2f8ea34.svg";
export { ForwardRef as ReactComponent };